import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


//SERVICES
import { SharedModule } from '../shared.module';
import { ConfigService } from '../services/config.service';
import { User, UserResult } from '../models/user';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import _map from 'lodash-es/map';
import _head from 'lodash-es/head';
import { AuthHandlerService } from 'src/app/auth/auth-handler.service';

@Injectable({providedIn: SharedModule})
export class CompassAPIUsersService {
	private _baseApiUrl: string;
	private _config; 
	constructor(
		private httpClient: HttpClient,
		_configService: ConfigService,
		private authHandler: AuthHandlerService) {
		this._baseApiUrl =  `${_configService.urls.baseUrl}/users`;//debugger;
		this._config = _configService; 
		this.authHandler.setOnAccountActivate(account=> {//debugger;			
			if (!this.authHandler.getAccountHasAcceptedInvite(account)) {
				this.acceptInvite(account.idTokenClaims.oid).pipe(first()).subscribe();
			}
		})
	}

    public saveUser(user: User) {
		const url = this.buildUrl();
		if (user.id) {		
			return this.httpClient.put<User>(`${url}${user.id}`, user);
		} else {
			return this.httpClient.post<User>(`${url}`, user);
		}
    }

    public getUserById(id: string): Observable<User> {
		const url = this.buildUrl();
		return this.httpClient.get<User>(`${url}${id}`);
    }

    public getUserByVendorId(vendorId: string): Observable<User> {
		return this.getAllUsers(1, null, null, vendorId).pipe(map(userResult => userResult && userResult.results ? _head(userResult.results): null));
    }

	public getAllUsers(limit: number = 5, skipToken: string = null, searchTerm: string = null, vendorId: string = null, role: string = null): Observable<UserResult> {
		//console.log('CompassAPIUsersService.getAllUsers', limit, skipToken, searchTerm);
		const url = this.buildUrl();
		return this.httpClient.get<UserResult>(`${url}?limit=${limit}&skipToken=${skipToken || ''}&searchTerm=${searchTerm || ''}&vendorId=${vendorId || ''}&role=${role || ''}`);
	}

	public acceptInvite(id: string) {
		const url = this.buildUrl('acceptinvite');
		return this.httpClient.post(url, { id });
	}

	public resendInvite(email: string) {
		const url = this.buildUrl('reinvite');
		return this.httpClient.post(url, { email });
	}

	public addToHubspot(id: string) {
		return this.httpClient.post(this.buildUrl("addtohubspot/" + id), {}, {headers: this._config.headers})
	}

	public updateLastVisited(url: string){
		return this.httpClient.post(this.buildUrl("UpateLastVisistedUrl"), {id: url});	
	}

	private buildUrl(path?: string) {
		return `${this._baseApiUrl}/${path ?? ''}`;
	}
}